const state = {
  downloadSizeInfo: new Map()
}

const getters = {
  downloadSizeInfo: state => state.downloadSizeInfo
}

const actions = {
  SET_DOWNLOAD_SIZE_INFO({ commit }, argument) {
    commit('SET_DOWNLOAD_SIZE_INFO', argument)
  },
}

const mutations = {
  SET_DOWNLOAD_SIZE_INFO(state, argument) {
    state.downloadSizeInfo.set(argument.index, { height: argument.height, width: argument.width })
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}